"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const Tab = ({ isActive, text, icon, onPress }) => {
    return (react_1.default.createElement(react_native_paper_1.Button, { buttonColor: isActive ? colors_1.default.BLUE : colors_1.default.WHITE, textColor: isActive ? colors_1.default.WHITE : colors_1.default.BLUE, icon: icon, mode: isActive ? 'contained' : 'elevated', onPress: onPress, style: styles_1.default.marginRightTen }, text));
};
exports.default = Tab;
